import React from 'react';
import { Flex } from '@bynder/design-system';
import Loader from 'packages/common/loader/Loader';
import generateTestId from 'packages/helpers/testIdHelpers';

const loaderTestId = generateTestId('old-page-loader');

export const PageLoader = () => {
    return (
        <Flex alignItems="center" justifyContent="center" {...loaderTestId}>
            <Loader size={50} />
        </Flex>
    );
};
